export default {
  title: "Member Dashboard",
  active: "active",
  loading: "Loading...",

  filters: {
    financialYear: "Financial Year",
    from: "From",
    to: "To",
  },

  actions: {
    refresh: "Refresh",
  },

  fallback: {
    noEmail: "No email",
    noPhone: "No phone",
  },

  kpis: {
    openingBalance: "Opening Balance",
    memberFunds: "Member Funds",
    activeInvestedAmount: "Active Invested Amount",
    loanEligibilityAmount: "Loan Eligibility Amount",
    outstandingLoanPrincipal: "Outstanding Loan Principal",
    netMemberPosition: "Net Member Position",
    unpaidPenalties: "Unpaid Penalties",
    unpaidItemsAcrossYears: "{count} current unpaid item(s), across years.",
  },

  flows: {
    contributionsIn: "Contributions In",
    outstandingLoanRepayments: "Outstanding Loan Repayments",
    penaltyPaymentIn: "Penalty Payment In",
    withdrawalsOut: "Withdrawals Out",
    includesProfitWithdrawals: "Includes profit withdrawals",
  },

  overdue: {
    title: "You have {count} overdue loan installment(s).",
    amount: "Overdue amount",
    oldestDueDate: "Oldest due date",
  },

  sections: {
    loans: "Loans",
    penalties: "Penalties",
    investments: "Investments",
    accountSummary: "Account Summary",
  },

  summary: {
    outstandingTotal: "Outstanding Total",
    outstandingPrincipal: "Outstanding Principal",
    outstandingInterest: "Outstanding Interest",
    outstandingScope: "Outstanding Scope",
    activeDefaultedCrossYear: "Active and defaulted loans, cross-year",
    repaymentCards: "Repayment Cards",
    outstandingSelectedPeriod: "Outstanding loans in selected period",
    activeLoans: "Active Loans",
    defaultedLoans: "Defaulted Loans",
    overdueInstallments: "Overdue Installments",
    overdueAmount: "Overdue Amount",
    oldestOverdueDate: "Oldest Overdue Date",
    unpaidCount: "Unpaid Count",
    unpaidAmount: "Unpaid Amount",
    createdThisPeriod: "Created This Period",
    paidThisPeriod: "Paid This Period",
    waivedThisPeriod: "Waived This Period",
    ownedFunds: "Owned Funds",
    activeInvestedAmount: "Active Invested Amount",
    loanEligibilityAmount: "Loan Eligibility Amount",
    availableShare: "Available Share",
    openingBalance: "Opening Balance",
    totalContributions: "Total Contributions",
    totalWithdrawals: "Total Withdrawals",
    memberFunds: "Member Funds",
    transactionsShown: "Transactions Shown",
  },

  details: {
    outstandingLoanCashRepayments: "Outstanding Loan Cash Repayments",
    repaymentsAppliedNote:
      "Repayments applied to active and defaulted loans in the selected period.",
    outstandingLoanPrincipalRepaid: "Outstanding Loan Principal Repaid",
    outstandingLoanInterest: "Outstanding Loan Interest",
    repayment: "Repayment",
    upfront: "Upfront",
    profitIn: "Profit In",
  },

  transactions: {
    title: "Recent Transactions",
    subtitle: "Latest records from your member ledger.",
    records: "{count} record(s)",
    loadingDashboard: "Loading dashboard...",
    empty: "No recent transactions found.",
    columns: {
      date: "Date",
      type: "Type",
      reference: "Reference",
      amount: "Amount",
    },
  },

  transactionTypes: {
    contribution: "Contribution",
    contributionReversal: "Contribution Reversal",
    contributionUndo: "Contribution Undo",
    loanRepayment: "Loan Repayment",
    loanRepaymentReversal: "Loan Repayment Reversal",
    loanRepaymentUndo: "Loan Repayment Undo",
    profit: "Profit",
    profitReversal: "Profit Reversal",
    profitWithdrawal: "Profit Withdrawal",
    profitWithdrawalReversal: "Profit Withdrawal Reversal",
    profitWithdrawalUndo: "Profit Withdrawal Undo",
    profitUndo: "Profit Undo",
    penaltyPayment: "Penalty Payment",
    penaltyPaymentReversal: "Penalty Payment Reversal",
    penaltyPaymentUndo: "Penalty Payment Undo",
    loanDisbursement: "Loan Disbursement",
    migratedOpeningLoan: "Migrated Opening Loan",
    openingBalance: "Opening Balance",
    upfrontLoanInterest: "Upfront Loan Interest",
    partialWithdrawal: "Partial Withdrawal",
    exitWithdrawal: "Exit Withdrawal",
    transaction: "Transaction",
  },

  errors: {
    loadFinancialYears: "Failed to load financial years.",
    selectFinancialYear: "Select a financial year.",
    selectBothDates: "Select both the start and end dates.",
    rangeWithinFinancialYear:
      "The selected date range must stay within the selected financial year.",
    startBeforeEnd: "The start date must not be after the end date.",
    loadDashboard: "Failed to load dashboard.",
    periodOutsideFinancialYear:
      "The requested period does not belong to the selected financial year.",
  },
};
